import {gql} from 'apollo-angular';

export const GET_ROOKIE_OFFER_TIME_SLOTS_REMAINING_SLOTS = gql`
  query RookieOfferTimeSlotsRemainingSlots($districtId: Int!) {
    rookieOfferTimeSlotsRemainingSlots(districtId: $districtId){
      type
      message
    }
  }
`;
